export const URL_LIBX_ROUTE = 'libxchange';
export const URL_SUFFIX_LIBX_ALL_TITLES = 'products';
export const URL_SUFFIX_LIBX_PRODUCT_DETAILS = 'products';
export const URL_SUFFIX_LIBX_PRODUCT_DETAILS_ID = ':productId';
export const URL_SUFFIX_LIBX_FEATURED = 'featured';
export const URL_SUFFIX_LIBX_NEWLY_ADDED = 'newlyadded';
export const URL_SUFFIX_LIBX_GENRES = 'genres';
export const URL_SUFFIX_LIBX_GENRES_ID = ':genre?/:subGenre?';
export const URL_SUFFIX_LIBX_LOCAL_REGIONS = 'localregions';
export const URL_SUFFIX_LIBX_LOCAL_REGIONS_ID = ':level1?/:level2?';
